// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/texteditor/index.scss
// module id = 2541
// module chunks = 13